import replaceAmberDomainInLinks from "@Utils/clientUtils/dangerouslySetInnerHtmlUtility/replaceAmberDomainInLinks";
import styles from "../USPSection.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";

const Disclaimer = ({ content }: any) => (
  <div className={styles.typography}>
    <div
      className={styles.disclaimerModalContent}
      dangerouslySetInnerHTML={{ __html: replaceAmberDomainInLinks(content) }}
    />
  </div>
);

export default wrapperHOC(Disclaimer, {
  componentName: "Disclaimer-PropertyUSPs-PropertyPage",
  showForChina: true,
});
